import React, { forwardRef, useRef, useEffect } from 'react';

const TableSelectionCheckBox = forwardRef(
  ({ indeterminate, event, ...rest }: any, ref: any) => {
    const defaultRef = useRef();
    const resolvedRef = ref || defaultRef;

    useEffect(() => {
      resolvedRef.current.indeterminate = indeterminate;
    }, [resolvedRef, indeterminate]);

    return (
      <>
        <input
          id="tableselectioncheckbox"
          data-testid="tableselectioncheckbox"
          className="form-checkbox w-4 h-4 rounded-sm !important"
          type="checkbox"
          ref={resolvedRef}
          {...rest}
        />
      </>
    );
  },
);

export default TableSelectionCheckBox;
